import { environment } from '../../../environments/environment';

const apiBaseUrl = environment.apiBaseUrl;

export const API_ENDPOINTS = {
  AUTH: {},
  ADMIN: {
    guestReferenceList: () => `${apiBaseUrl}/admin/guest/reference-list`,

    guestReferenceDetails: (id: number) => `${apiBaseUrl}/admin/guest/reference-details/${id}`,

    guestReferenceEdit: (reference_id: number) => `${apiBaseUrl}/admin/guest/edit-reference-details/${reference_id}`,

    guestContestList: () => `${apiBaseUrl}/admin/contest-guest-list`,

    sendMessageNotification: () => `${apiBaseUrl}/admin/contest/send-message-notification`,

    getContestBadge: () => `${apiBaseUrl}/admin/guest/fetch-contest-badge`,

    createContest: () => `${apiBaseUrl}/admin/contest/create`,

    updateContest: () => `${apiBaseUrl}/admin/contest/edit`,

    getContestDetails: (id: string) => `${apiBaseUrl}/admin/contest/${id}/details`,

    mobileSettingDetails: (id: string) => `${apiBaseUrl}/admin/setting/mobile-settings-details/${id}`,

    mobileSettingUpdate: (id: string) => `${apiBaseUrl}/admin/setting/edit-mobile-settings/${id}`,

    createAnnouncement: () => `${apiBaseUrl}/admin/add-announcements`,

    fetchAnnouncementList: () => `${apiBaseUrl}/admin/announcements/list`,

    updateAnnouncementStatus: () => `${apiBaseUrl}/admin/update-status`,

  },
  BILLS: {
    aggregatedInvoiceDetails: (invoiceId: number) =>
      `${apiBaseUrl}/billing/billing/bihar-ppp/aggregated-invoice-details/${invoiceId}`,

    aggregatedInvoiceNullify: () => `${apiBaseUrl}/billing/bihar-invoice-nullify`,

    acquisitionAttritionReports: () => `${apiBaseUrl}/billing/acquisition-attrition-report-list`,

    biharPppDetails: (pkId: number) => `${apiBaseUrl}/billing/bihar-ppp-details/${pkId}`,

    biharPppDetailsUpdate: () => `${apiBaseUrl}/billing/bihar-ppp-details/create-or-update`,

    createBill: () => `${apiBaseUrl}/billing/bill/create`,

    createInvoice: () => `${apiBaseUrl}/billing/bihar-invoice/create`,

    createPreAuth: () => `${apiBaseUrl}/billing/pre-auth/create`,

    monthlyInvoiceDetails: () => `${apiBaseUrl}/billing/bihar-ppp/monthly-invoice/`,

    listBiharBillSummary: () => `${apiBaseUrl}/billing/bihar-ppp/bill-summary/`,

    listCenters: () => `${apiBaseUrl}/billing/pre-auth/center`,

    listItemByRatePlanId: () => `${apiBaseUrl}/billing/billing/items`,

    listPreAuth: () => `${apiBaseUrl}/billing/pre-auth/list`,

    updatePreAuth: (_id: string) => `${apiBaseUrl}/billing/pre-auth/update/${_id}`,

    viewPreAuth: (_id: string) => `${apiBaseUrl}/billing/pre-auth/list/${_id}`,

    activePackagesList: (guestId: number) => `${apiBaseUrl}/billing/active-package/${guestId}`,

    couponsList: (guestId: number) => `${apiBaseUrl}/billing/coupon/${guestId}`,

    lastBillStatus: (centerId: number) => `${apiBaseUrl}/billing/billing/last-bill-status/${centerId}`,

    listRatePlanList: () => `${apiBaseUrl}/billing/billing/rateplans-list`,

    listRatePlansAllList: () => `${apiBaseUrl}/billing/billing/rateplans-all-list`,

    noOfCycle: (centerId: number) => `${apiBaseUrl}/billing/bill-cycle/${centerId}`,

    previousBillsList: (guestId: number) => `${apiBaseUrl}/billing/billing/previous_bill/${guestId}`,

    ratePlanItemsList: () => `${apiBaseUrl}/billing/billing/items`,

    allItemsList: () => `${apiBaseUrl}/billing/billing/items-list`,

    ratePlanDetailsById: (ratePlanId: string) => `${apiBaseUrl}/billing/billing/rateplan-details/${ratePlanId}`,

    ratePlansByGuestId: (guestId: number) => `${apiBaseUrl}/billing/billing/rateplans/${guestId}`,

    ratePlanTypeList: () => `${apiBaseUrl}/billing/rateplantype-list`,

    viewDeposit: (guestId: number) => `${apiBaseUrl}/billing/deposit/${guestId}`,

    sessionDateConfig: (centerId: number) => `${apiBaseUrl}/billing/sessiondate_configuration/${centerId}`,

    cashReconDateConfig: (centerId: number) => `${apiBaseUrl}/billing/cashrecon_configuration/${centerId}`,

    updateBiharInvoice: (_id: number) => `${apiBaseUrl}/billing/bihar-invoice/modify/${_id}`,

    updateBiharFinanceInvoice: () => `${apiBaseUrl}/billing/bihar-invoice/bihar-finance-modify/`,

    deleteAcknowledgementLetter: (invoiceId: number) => `${apiBaseUrl}/billing/bihar-invoice/nullify-cs-fields/${invoiceId}`,

    billNullify: () => `${apiBaseUrl}/billing/bill/nullify`,

    billShareEmailSms: (billNo: string) => `${apiBaseUrl}/billing/bill/share/${billNo}`,

    todaysCollectionReport: () => `${apiBaseUrl}/billing/todays-collection-report`,

    changeBillStatus: (centerId: number) => `${apiBaseUrl}/billing/changes-bill-status/${centerId}`,

    totalAmountTodaysCollectionReport: () => `${apiBaseUrl}/billing/collection-report-list/total-amount`,

    fetchDraftBillList: () => `${apiBaseUrl}/guest/center_guest_tokens`,

    fetchPosMachineList: (centerId: number) => `${apiBaseUrl}/billing/center-pos-machines/${centerId}`,

    scheduledDraftBillNullify: () => `/api/billing/scheduled-draft-bill-nullify`,

    nullifyAllDraftBillsForGuestExpired: (guestId: number) =>
      `/api/billing/nullify-all-draft-bills-for-guest-expired/${guestId}`,

    fetchMachineList: () => `${apiBaseUrl}/billing/billing/machine-list`,

    fetchMachineListstatus: () => `${apiBaseUrl}/billing/billing/machine-list-status`,

    fetchMachineListmachinetype: () => `${apiBaseUrl}/billing/billing/machine-list-machinetype`,

    fetchMachineListmanufacturer: () => `${apiBaseUrl}/billing/billing/machine-list-manufacturer`,

    fetchMachineListassettype: () => `${apiBaseUrl}/billing/billing/machine-list-assettype`,

    fetchMachineListassettypecount: () => `${apiBaseUrl}/billing/billing/machine-asset-type-count`,

    fetchCustomerServiceList: (selectedDate: any) =>`${apiBaseUrl}/billing/billing/customer_service/${selectedDate}`,

    fetchCustomerServicetimings: () => `${apiBaseUrl}/billing/billing/customer_service_slot_details`,

    guestWeightsList: () => `${apiBaseUrl}/billing/guest/session-weights`,

  },
  BILL_REPORT: {
    billDetails: (billId: string) => `${apiBaseUrl}/report/bill/${billId}`,

    collectionReport: () => `${apiBaseUrl}/report/collection-report-list`,

    depositUtilizationReports: () => `${apiBaseUrl}/report/deposit-utilization-report`,

    fetchYesterdaysRevenueReport: () => `${apiBaseUrl}/report/yesterdays-guest-session-revenue-report`,

    listBills: () => `${apiBaseUrl}/report/bill_list`,

    listUsedBillPreAuth: () => `${apiBaseUrl}/report/pre-auth/used-bills`,

    packageUtilizationReports: () => `${apiBaseUrl}/report/package-utilization-report-list`,

    TodaysRevenueReport: () => `${apiBaseUrl}/billing/todays-revenue-report`,

    totalCollectionReport: () => `${apiBaseUrl}/report/collection-report-list/total-amount`,

    totalDepositUtilizationReport: () => `${apiBaseUrl}/report/total-deposit-utilization-report`,

    totalYesterdaysRevenueReports: () => `${apiBaseUrl}/report/yesterdays-guest-session-revenue-report/total-amount`,

    todaysBillList: () => `${apiBaseUrl}/report/bo/bill_list`,

    todaysBilldetails: (id: string) => `${apiBaseUrl}/report/bo/bill/${id}`,
  },
  BIHARPP_DASHBOARD: {
    centerList: () => `${apiBaseUrl}/guest/bihar-ppp-dashboard/fetch-center-list/`,

    dashboardData: () => `${apiBaseUrl}/guest/bihar-ppp-dashboard/fetch-aggregate-count-list/`,

    dashboardDataCount: () => `${apiBaseUrl}/guest/bihar-ppp-dashboard/fetch-aggregate-count/`,

    ratePlanList: () => `${apiBaseUrl}/guest/bihar-ppp-dashboard/fetch-rateplan-list/`,
  },
  CENTER: {
    centerDetailsById: (id: string) => `${apiBaseUrl}/billing/center/${id}`,

    centerList: () => `${apiBaseUrl}/billing/center-list`,

    centerUpdate: (centerId: string) => `${apiBaseUrl}/billing/center/update/${centerId}`,

    centerRoles:()=> `${apiBaseUrl}/billing/get_roles_list_for_center`,

    centerRoleBasedStaff:()=> `${apiBaseUrl}/billing/get_staff_for_the_role_and_center`,

  },
  CLINICAL: {
    accessList: () => `${apiBaseUrl}/clinical/access-list-report/`,

    hepBVaccinationReport: () => `${apiBaseUrl}/clinical/prescription/hep_b_vaccination_report`,

    prescriptionEntry: () => `${apiBaseUrl}/clinical/prescription-entry/`,

    viralMarkersReport: () => `${apiBaseUrl}/clinical/viral-markers-report/get-list`,

    createAdverseEvent: () => `${apiBaseUrl}/clinical/create-adverse-event`,

    updateAdverseEvent: (eventId: number) => `${apiBaseUrl}/clinical/update-adverse-event/${eventId}`,

    investigationReport: () => `${apiBaseUrl}/clinical/investigation-report`,

    adverseEventList: () => `${apiBaseUrl}/clinical/adverse-event-report`,

    adverseEventDetails: (eventId: number) => `${apiBaseUrl}/clinical/get-adverse-event/${eventId}`,

    createInvestigation: () => `${apiBaseUrl}/clinical/investigation/create`,

    investigationDetails: (reportId: number) => `${apiBaseUrl}/clinical/investigation-report-detail/${reportId}`,

    updateInvestigation: (id: string) => `${apiBaseUrl}/clinical/investigation/update/${id}`,

    clinicalS3Upload: () => `${apiBaseUrl}/clinical/s3/upload`,

    getClinicalS3Url: () => `${apiBaseUrl}/clinical/get-s3-url`,

    monthlySummaryReport: () => `${apiBaseUrl}/clinical/clinical-monthly-report/`,

    monthlyInvestigationSummaryReport: () => `${apiBaseUrl}/clinical/monthly-investigation-summary`,

    eq5dQualitySurveyCreate: () => `${apiBaseUrl}/clinical/eq5d_quality_survey/create`,

    eq5dQualitySurveyList: () => `${apiBaseUrl}/clinical/eq5d_quality_survey/view`,

    prescriptionDetailReport: () => `${apiBaseUrl}/clinical/guest-prescription-report/`,

    centerLongitudinalReport: () => `${apiBaseUrl}/clinical/center-longitudinal-report`,

    guestSpecificLongitudinalReport: () => `${apiBaseUrl}/clinical/guest-specific-longitudinal-report`,

    getInvestigationUnits: () => `${apiBaseUrl}/clinical/investigation/master`,

    ocrLabReportDataCreate: (centerId: number, guestId: number, investigationId: string, reportType: string) =>
      `${apiBaseUrl}/clinical/ocr-lab-report-data-create?centerId=${centerId}&guestId=${guestId}&investigationId=${investigationId}&reportType=${reportType}`,

    getLabReportData: () => `${apiBaseUrl}/clinical/get-lab-report-data`,

    updateLabReportData: () => `${apiBaseUrl}/clinical/update-ocr-info-status`,

    investigationDataValueUpdate: (id: number) => `${apiBaseUrl}/clinical/investigation-data-value-update/${id}`,

    callBackApi: () => `${apiBaseUrl}/clinical/ocr-write-lab-report-data`,
  },
  COMMON: {
    uploadFile: () => `${apiBaseUrl}/guest/bihar-ppp/image-upload/`,

    s3Upload: () => `${apiBaseUrl}/billing/s3/upload`,

    s3MultipleUpload: () => `${apiBaseUrl}/billing/s3/multiple-upload`,

    getS3Url: () => `${apiBaseUrl}/billing/get-s3-url`,
  },

  DASHBOARD: {
    overviewList: () => `${apiBaseUrl}/admin/dashboard-overview`,

    overviewSessionCount: () => `${apiBaseUrl}/admin/dashboard-overview-sessions-done`,

    openticketsList: () => `${apiBaseUrl}/guest/dashboard-opentickets`,

    todaysSchedule: () => `${apiBaseUrl}/guest/dashboard-todaysschedule`,

    quicklinks: () => `${apiBaseUrl}/guest/dashboard-quick-links`,
    
  },
  DOWNLOADS: {
    downloadList: () => `${apiBaseUrl}/report_export/report-jobs`,

    downloadReport: () => `${apiBaseUrl}/report_export/download-report`,

    fetchReportFromS3: (reportId: string) => `${apiBaseUrl}/report_export/download-report/${reportId}`,

    getS3Url: () => `${apiBaseUrl}/report_export/get-s3-url`,
  },
  GUEST: {
    abdmAccessToken: () => `${apiBaseUrl}/guest/abdm/accesstoken`,

    abdmAadhaaarOtp: () => `${apiBaseUrl}/guest/abdm/aadhaar/generateotp`,

    abdmVerifyAadhaaarOtp: () => `${apiBaseUrl}/guest/abdm/aadhaar/verifyotp`,

    abdmAadhaaarMobileOtp: () => `${apiBaseUrl}/guest/abdm/aadhaar/generatemobileotp`,

    abdmVerifyAadhaaarMobileOtp: () => `${apiBaseUrl}/guest/abdm/aadhaar/verifymobileotp`,

    abdmCreateHealthId: () => `${apiBaseUrl}/guest/abdm/aadhaar/createhealthid`,

    abdmGetAbhaCard: () => `${apiBaseUrl}/guest/abdm/aadhaar/getabhacard`,

    abdmGetProfile: () => `${apiBaseUrl}/guest/abdm/profile`,

    abdmSearchHealthId: () => `${apiBaseUrl}/guest/abdm/aadhaar/searchhealthid`,

    abdmSearchHealthIdOtp: () => `${apiBaseUrl}/guest/abdm/aadhaar/searchhealthidotp`,

    abdmLinkHealthIdWithNumber: () => `${apiBaseUrl}/guest/abdm/aadhaar/linkhealthidwithnumber`,

    abdmXtoken: () => `${apiBaseUrl}/guest/abdm/xtoken`,

    approvalPendingBhavyaPatientList: () => `${apiBaseUrl}/guest/approval-pending-guests-with-bhavya-id`,

    createGuest: () => `${apiBaseUrl}/guest/create-guest/new`,

    createGuestToAzureDB: () => `${apiBaseUrl}/guest/create-guest-mssql/new`,

    createTempGuest: () => `${apiBaseUrl}/guest/create-guest/temp`,

    createPrescription: (guestId: number) => `${apiBaseUrl}/guest/guest-prescription-create/?guest_id=${guestId}`,

    easyEdit: (guestId: number) => `${apiBaseUrl}/guest/guest-easy-edit/${guestId}`,

    guestDetails: (guestId: number) => `${apiBaseUrl}/guest/guest-info/${guestId}`,

    guestsList: () => `${apiBaseUrl}/guest/guest-list`,

    listGeneralInsurance: () => `${apiBaseUrl}/guest/general-insurance/list`,

    nephrologistList: (centerId: number | string) => `${apiBaseUrl}/guest/nephrologist/list/${centerId}`,

    paymentModeList: () => `${apiBaseUrl}/guest/payment-type/list`,

    prescriptionList: (guestId: string) => `${apiBaseUrl}/guest/guest-prescription-list/?guest_id=${guestId}`,

    prescriptionDelete: (prescriptionId: number) => `${apiBaseUrl}/guest/guest-prescription-delete/${prescriptionId}`,

    prescriptionEdit: (prescriptionId: number) => `${apiBaseUrl}/guest/guest-prescription-update/${prescriptionId}`,

    medicationList: () => `${apiBaseUrl}/guest/medication/list`,

    biharPppGuestApprovalStatus: (guestId: number) => `${apiBaseUrl}/guest/approval-status/update/${guestId}`,

    updateGuestDetails: (guestId: number) => `${apiBaseUrl}/guest/guest-edit/${guestId}`,

    futureNullifiableItems: (guestId: number) => `${apiBaseUrl}/guest/future-nullifiable-items/${guestId}`,

    uploadFile: () => `${apiBaseUrl}/guest/bihar-ppp/image-upload/`,

    couponDownload: (guestId: number) => `${apiBaseUrl}/guest/guest/coupon-code/${guestId}`,

    sendOtp: () => `${apiBaseUrl}/guest/send-mobile-otp-guest-and-staff`,

    otpVerification: () => `${apiBaseUrl}/guest/mobile-otp-verification-guest-and-staff`,

    guestIrregularReport: () => `${apiBaseUrl}/guest/guest-irregular-report/`,

    updateTempGuest: (guestId: string) => `${apiBaseUrl}/guest/temp-guest-edit/${guestId}`,

    fetchServiceWiseItemCountList: () => `${apiBaseUrl}/guest/service-wise-item-count`,

    updateIncenterAppGuest: () => `${apiBaseUrl}/guest/create-update-guest/push-to-incenter`,

    fetchCountryCode: () => `${apiBaseUrl}/guest/country-codes/list`,

    getGuestToken: (guestId: string) => `${apiBaseUrl}/guest/guest_token/${guestId}`,

    centerWiseNephrologistList: (centerId: number | string) => `${apiBaseUrl}/guest/center_wise_nephrologists/${centerId}`,

    updateGuestWeightInfo: () => `${apiBaseUrl}/guest/add-dialysis-weight-info`,

    saveRenalFollowUp: (guestId: number) => `${apiBaseUrl}/guest/renal-annual-followup/${guestId}`,

    renalReplacementHistoryById: (id: number) => `${apiBaseUrl}/guest/guest-info/renal-replacement-history/${id}`,

    updateRenalReplacementHistory: (id: number) => `${apiBaseUrl}/guest/guest-edit/renal-replacement-history/${id}`,

  },
  HR: {
    // createStaff: () => `${apiBaseUrl}/hr/create-staff`,
    createStaff: (queryParams: any) => {
      const queryString = new URLSearchParams(queryParams).toString();
      
      return `${apiBaseUrl}/hr/create-staff?${queryString}`;
    },
    

    listRoles: (category: string) => `${apiBaseUrl}/hr/list/${category}`,

    listStatus: (category: string) => `${apiBaseUrl}/hr/list/${category}`,

    masquerade: () => `${apiBaseUrl}/hr/masquerade/`,

    listKeycloakRoles: () => `${apiBaseUrl}/hr/roles`,

    listKeycloakRolesPermission: () => `${apiBaseUrl}/hr/scope-list`,

    myPermissions: () => `${apiBaseUrl}/hr/me/permissions`,

    staffList: () => `${apiBaseUrl}/hr/staff-list`,

    updateStaff: (staffId: number) => `${apiBaseUrl}/hr/update-staff/${staffId}`,

    updateStaffByUser: (staffId: number) => `${apiBaseUrl}/hr/update-staff-with-user/${staffId}`,

    updateRolePermission: () => `${apiBaseUrl}/hr/update_role`,

    userNameBulkList: (username: string) => `${apiBaseUrl}/hr/list/${username}`,

    viewStaff: () => `${apiBaseUrl}/hr/view-staff`,

    updateIncenterStaff: () => `${apiBaseUrl}/hr/create-update-technician/push-to-incenter`,

    fetchDepartmentList: ()=>`${apiBaseUrl}/hr/department-list`,

    fetchReportingManagerList: ()=>`${apiBaseUrl}/hr/reporting-manager-list`,

    fetchZoneList: ()=>`${apiBaseUrl}/hr/zone-list`
  },
  // Cognito + DB backed HR (parallel to HR; powers the `newhr` module). Staff goes to the
  // -cognito endpoints; roles/permissions use the new DB CRUD. Unchanged endpoints (view-staff,
  // staff-list, master lists, department/zone/manager) are reused verbatim.
  NEWHR: {
    createStaff: (queryParams: any) => {
      const queryString = new URLSearchParams(queryParams).toString();

      return `${apiBaseUrl}/hr/create-staff-cognito?${queryString}`;
    },

    updateStaff: (staffId: number) => `${apiBaseUrl}/hr/update-staff-cognito/${staffId}`,

    updateStaffByUser: (staffId: number) => `${apiBaseUrl}/hr/update-staff-with-user/${staffId}`,

    viewStaff: () => `${apiBaseUrl}/hr/view-staff`,

    staffList: () => `${apiBaseUrl}/hr/staff-list`,

    masquerade: () => `${apiBaseUrl}/hr/masquerade/`,

    listRoles: (category: string) => `${apiBaseUrl}/hr/list/${category}`,

    listStatus: (category: string) => `${apiBaseUrl}/hr/list/${category}`,

    updateIncenterStaff: () => `${apiBaseUrl}/hr/create-update-technician/push-to-incenter`,

    fetchDepartmentList: () => `${apiBaseUrl}/hr/department-list`,

    fetchReportingManagerList: () => `${apiBaseUrl}/hr/reporting-manager-list`,

    fetchZoneList: () => `${apiBaseUrl}/hr/zone-list`,

    // --- new DB + Cognito roles/permissions CRUD ---
    dbRoles: () => `${apiBaseUrl}/hr/db-roles`,

    createRole: () => `${apiBaseUrl}/hr/roles`,

    deleteRole: (roleId: string) => `${apiBaseUrl}/hr/roles/${roleId}`,

    rolePermissions: (roleId: string) => `${apiBaseUrl}/hr/roles/${roleId}/permissions`,

    permissions: () => `${apiBaseUrl}/hr/permissions`,

    cognitoGroups: () => `${apiBaseUrl}/hr/cognito-groups`,

    // Master-data create for the Cognito flow (creates the row only, no Keycloak). The role's
    // Cognito group + KcRole are created via createRole() using the returned master_data id.
    masterDataCreate: () => `${apiBaseUrl}/guest/master-data/create-cognito`,
  },
  MASTER_DATA: {
    createPrice: () => `${apiBaseUrl}/billing/billing/bihar-ppp/dialysis-session-price/create-update`,

    centerPriceList: () => `${apiBaseUrl}/billing/billing/bihar-ppp/dialysis-session-price/list`,

    clinicalInvestigationList: () => `${apiBaseUrl}/clinical/investigation/master`,

    paymentStatusUpdate:()=> `${apiBaseUrl}/billing/center/payment-update`,

    rrTypeMasterUpdate:()=> `${apiBaseUrl}/rr/rr_type/update`,
    
    investigationDataUpdate: (id: number) => `${apiBaseUrl}/clinical/investigation/master/${id}`,

    languageList: () => `${apiBaseUrl}/guest/language/list`,

    manualAuditMasterCreate: () => `${apiBaseUrl}/operations/audit-item-create`,

    manualAuditMasterDelete: (id: number) => `${apiBaseUrl}/operations/audit-item-delete/${id}`,

    manualAuditMasterList: () => `${apiBaseUrl}/operations/audit-item-list`,

    manualAuditMasterUpdate: (id: number) => `${apiBaseUrl}/operations/audit-item-update/${id}`,

    medicationMasterCreate: () => `${apiBaseUrl}/guest/medication/create`,

    medicationMasterList: () => `${apiBaseUrl}/guest/medication/list`,

    medicationMasterListById: (id: number) => `${apiBaseUrl}/guest/medication/list/${id}`,

    medicationMasterUpdate: (id: number) => `${apiBaseUrl}/guest/medication/update/${id}`,

    medicationMasterDelete: (id: number) => `${apiBaseUrl}/guest/medication/delete/${id}`,

    masterDataCreate: () => `${apiBaseUrl}/guest/master-data/create`,

    masterDataCreateByLanguage: () => `${apiBaseUrl}/guest/language-based-master-data/create`,

    masterDataDelete: (id: number) => `${apiBaseUrl}/guest/master-data/delete/${id}`,

    masterDataDeleteByLanguage: (id: number) => `${apiBaseUrl}/guest/language-based-master-data/delete/${id}`,

    masterDataList: () => `${apiBaseUrl}/guest/master-data/list`,

    masterDataListById: (id: number) => `${apiBaseUrl}/guest/master-data/list/${id}`,

    masterDataListByIdLanguage: (id: number) => `${apiBaseUrl}/guest/language-based-master-data/list/${id}`,

    masterDataListByLanguage: () => `${apiBaseUrl}/guest/language-based-master-data/list`,

    masterDataUpdate: (id: number) => `${apiBaseUrl}/guest/master-data/update/${id}`,

    masterDataUpdateByLanguage: (id: number) => `${apiBaseUrl}/guest/language-based-master-data/update/${id}`,

    paymentCreate: () => `${apiBaseUrl}/guest/create-payment-type`,

    paymentRatePlanUpdate: (id: number) => `${apiBaseUrl}/guest/update-payment-type/${id}`,

    ratePlanList: () => `${apiBaseUrl}/billing/billing/rateplans-list`,

    eq5dMasterData: () => `${apiBaseUrl}/clinical/eq5d_master/get`,

    getSessionCount: () => `${apiBaseUrl}/guest/get-session-count-list/`,

    createSessionCount: () => `${apiBaseUrl}/guest/add-session-count/`,

    updateSessionCount: (id: string) => `${apiBaseUrl}/guest/update-session-count/${id}`,

    fetchGenericConfigList: () => `${apiBaseUrl}/operations/debit-note/generic-configuration/list`,

    changeGenericConfigStatus: () => `${apiBaseUrl}/operations/toggle-debit-note-status`,

    addNewConfiguration: () => `${apiBaseUrl}/operations/configuration/create`,

    updateGenConfiguration: (id: number) => `${apiBaseUrl}/operations/configuration/update/${id}`,

    inventoryConfigCreate: () => `${apiBaseUrl}/operations/auto-inventory-configration/create`,

    updateInventoryConfig: (id: string) => `${apiBaseUrl}/operations/auto-inventory-configration/update/${id}`,

    fetchInventoryConfigList: () => `${apiBaseUrl}/operations/auto-inventory-configration/list`,

    deleteInventoryConfigData: (id: number) => `${apiBaseUrl}/operations/auto-inventory-configration/delete/${id}`,

    fetchSCMConfigList: () => `${apiBaseUrl}/billing/center-list`,
    
    updateSCMConfig: (id : number) => `${apiBaseUrl}/billing/center/grn-update/${id}`,

    fetchCenterWiseToDoList: () => `${apiBaseUrl}/admin/centers-todo-list`,

    fetchTODOMasterList: () => `${apiBaseUrl}/admin/todos`,

    saveTODOList: () => `${apiBaseUrl}/admin/center-todos-saving`,

    updateToDoStatus:()=> `${apiBaseUrl}/admin/todos/update-status`,

    fetchToDoConfigList: () => `${apiBaseUrl}/admin/todos`,

    verifyToDoOtp:(otp: number) => `${apiBaseUrl}/admin/bypass_verify_otp?otp=${otp}`,

    sendTodoOtp: () => `${apiBaseUrl}/admin/bypass_generate_otp`,

    fetchToDoValidation: () => `${apiBaseUrl}/admin/centers-todo`,

    createBulkMasterAttrion: () => `${apiBaseUrl}/guest/master-attrition/create-bulk`,

    getMasterAttrionWithDetails: (masterId: number) => `${apiBaseUrl}/guest/master-attrition/by-master-with-details/${masterId}`,

    updateMasterAttrionByMaster: (masterId: number) => `${apiBaseUrl}/guest/master-attrition/update-by-master-id/${masterId}`,

    deleteMasterAttrion: (id: number) => `${apiBaseUrl}/guest/master-attrition/delete/${id}`,

    getAttrionReasonsByGuestType: (guestTypeId: number) => `${apiBaseUrl}/guest/master-attrition/by-guest-type/${guestTypeId}`,

   
  },

  MOBILE_API: {
    contestBadgeList: () => `${apiBaseUrl}/admin/guest/fetch-contest-badge`,

    contestBadgeDetail: (id: number) => `${apiBaseUrl}/admin/guest/contest-badge-details/${id}`,

    contestBadgeEdit: (id: number) => `${apiBaseUrl}/admin/guest/edit-contest-badge/${id}`,

    contestBadgeCreate: () => `${apiBaseUrl}/admin/guest/create-contest-badge`,

    contestDetails: (id: string) => `${apiBaseUrl}/admin/contest/${id}/details`,

    contestGuestList: (size: number, page: number) =>
      `${apiBaseUrl}/admin/contest-guest-list?size=${size}&page=${page}`,

    contestList: () => `${apiBaseUrl}/admin/contest/list`,

    deleteContestQuestions: (id: number) => `${apiBaseUrl}/admin/contest/edit/${id}`,

    dieticianAnswerRatingsList: () => `${apiBaseUrl}/admin/dietician/answer-ratings`,

    dieticianAnswerRatingById: () => `${apiBaseUrl}/admin/dietician/answer-ratings-by-id/`,

    dieticianAnswerRatingEdit: () => `${apiBaseUrl}/admin/dietician/update-answer-ratings-by-id/`,

    dieticianQuestionList: () => `${apiBaseUrl}/admin/dietician/questions`,

    fetchFAQById: (id: string) => `${apiBaseUrl}/admin/guest/fetch-faq-details/${id}`,

    guestQuerriesList: () => `${apiBaseUrl}/admin/guest/query-list`,

    listFAQ: () => `${apiBaseUrl}/admin/guest/fetch-faq-list`,

    mobileCenterRatingList: () => `${apiBaseUrl}/admin/guest/fetch-mobile-center-rating-list`,

    nephrologistCenterRatingDetails: () => `${apiBaseUrl}/admin/nephrologist/rating-centers-detail`,

    nephrologistCenterRatingList: () => `${apiBaseUrl}/admin/nephrologist/rating-centers`,

    nephrologistCenterRatingUpdate: () => `${apiBaseUrl}/admin/nephrologist/rating-centers-update`,

    nephrologistQuestionsList: () => `${apiBaseUrl}/admin/nephrologist/question-list`,

    nephrologistQuestionRatingDetails: () => `${apiBaseUrl}/admin/nephrologist/question-details/`,

    nephrologistQuestionRatingUpdate: () => `${apiBaseUrl}/admin/nephrologist/question-edit/`,

    nephrologistQuestionRatingList: () => `${apiBaseUrl}/admin/nephrologist/rating-for-nephrologist-answer`,

    sendContest: () => `${apiBaseUrl}/admin/contest/send-notification`,

    sendGreetings: () => `${apiBaseUrl}/admin/greetings/send`,

    updateFAQ: () => `${apiBaseUrl}/admin/guest/edit-faq`,

    createFAQ: () => `${apiBaseUrl}/admin/guest/create-faq`,

    ViewGuestQuerry: (queryId: number) => `${apiBaseUrl}/admin/guest/query-details/${queryId}`,
  },

  SCHEDULE_SESSION: {
    createSession: () => `${apiBaseUrl}/billing/guest-schedule-weekly-allocation/`,

    cycleConfiguration: () => `${apiBaseUrl}/billing/center-cycle-configuration/`,

    downloadSession: () => `${apiBaseUrl}/billing/download-schedules-guest/`,

    getScheduledSessionBetweenDates: (centerId: number, fromDate: string, toDate: string) =>
      `${apiBaseUrl}/billing/get_schedules/${centerId}/from_date/${fromDate}/to_date/${toDate}`,

    guestListByDiseaseType: (centerId: number) => `${apiBaseUrl}/billing/guest-list-by-disesase-type/${centerId}`,

    missedSessions: () => `${apiBaseUrl}/billing/view-missed-session/`,
  },

  SCM: {
    listPurchaseOrder: () => `${apiBaseUrl}/scm/purchase_order/list`,

    purchaseOrderDetail: () => `${apiBaseUrl}/scm/scm_purchase/get_detail`,

    transfersList: () => `${apiBaseUrl}/scm/scm_transfers/get_list`,

    transfersDetail: () => `${apiBaseUrl}/scm/scm_transfers/get_detail`,

    transferOrderAddGrn: (id: string, centerId: string) => `${apiBaseUrl}/scm/transfer_order/add-GRN/${id}/${centerId}`,

    purchaseOrderAddGrn: (id: string, centerId: string) => `${apiBaseUrl}/scm/purchase_order/add-GRN/${id}/${centerId}`,

    inventoryCenterWiseReportList: (centerId: string, size: number, page: number) =>
      `${apiBaseUrl}/auto-inventory-deviation-report-center-wise/list?centerId=${centerId}&page=${page}&size=${size}'`,

    validate_invoice: () => `${apiBaseUrl}/scm/check-invoice-validity`,

    generateRfidTag: () => `${apiBaseUrl}/scm/rfid-request`,

    getPORfIdItems: () => `${apiBaseUrl}/scm/grn-items-rfids`,

    getFARMastersList: () => `${apiBaseUrl}/scm/far-master-list`,

    upsertFARItem: () => `${apiBaseUrl}/scm/far-item-master`,

    getFARItemsList: () => `${apiBaseUrl}/scm/far-item-master-list`,

    grnHistory: () => `${apiBaseUrl}/scm/grn-history`,

    grnStatuses: () => `${apiBaseUrl}/scm/grn-status`,

    upsertPOGRNBlocking: () => `${apiBaseUrl}/scm/po-grn-blocking-configuration`,

    upsertTRGRNBlocking: () => `${apiBaseUrl}/scm/tr-grn-blocking-configuration`,

    fetchPOGRNBlockingList: () => `${apiBaseUrl}/scm/po-grn-blocking-list`,

    fetchTRGRNBlockingList: () => `${apiBaseUrl}/scm/tr-grn-blocking-list`,

    fetchPOTypes: () => `${apiBaseUrl}/scm/po-type-list`,
  
  },

  OPERATIONS: {
    createCashDeposit: () => `${apiBaseUrl}/operations/cash-deposit/create`,

    getAuditReportDetails: (id: number) => `${apiBaseUrl}/operations/audit-report/${id}`,

    getCashDepositDetails: (id: number) => `${apiBaseUrl}/operations/cash-deposit/${id}`,

    updateCashDeposit: (id: number) => `${apiBaseUrl}/operations/cash-deposit/update/${id}`,

    updateAuditReportStatus: (id: number) => `${apiBaseUrl}/operations/audit-report/status-change/${id}`,

    createAuditReport: () => `${apiBaseUrl}/operations/audit-report/create`,

    editAuditReport: (id: number) => `${apiBaseUrl}/operations/audit-report/edit/${id}`,

    getCashDepositReportDetails: (id: number) => `${apiBaseUrl}/operations/cash-deposit/${id}`,

    getCashDepositReportList: () => `${apiBaseUrl}/operations/cash-deposit`,

    getCashReconReportDetails: () => `${apiBaseUrl}/operations/cash-recon-list`,

    getCashReconReportExport: () => `${apiBaseUrl}/report_export/cash-recon-list`,

    listAuditReport: () => `${apiBaseUrl}/operations/audit-report`,

    listDialyReport: () => `${apiBaseUrl}/operations/daily-report`,

    fetchOperationsDailyReport: (id: string) => `${apiBaseUrl}/operations/daily-report/${id}`,

    createOperationsDailyReport: () => `${apiBaseUrl}/operations/daily-report/create`,

    updateOperationsDailyReport: (id: string) => `${apiBaseUrl}/operations/daily-report/update/${id}`,

    createManualAuditReport: () => `${apiBaseUrl}/operations/create-audit-report`,

    fetchAuditItemList: () => `${apiBaseUrl}/operations/audit-items-list`,

    updateManualAuditReport: (id: number) => `${apiBaseUrl}/operations/update-audit-report/${id}`,

    sampleMasterDataList: (id: number) => `${apiBaseUrl}/operations/audit-sample-list-all/${id}`,

    sampleMasterDataDelete: (id: number) => `${apiBaseUrl}/operations/audit-sample-delete/${id}`,

    createAuditSampleReport: () => `${apiBaseUrl}/operations/audit-sample/create`,

    editAuditSampleReport: (id: number) => `${apiBaseUrl}/operations/audit-sample-edit/${id}`,

    listRevenueDailyReport: () => `${apiBaseUrl}/operations/revenue-report-vs-daily-report-session`,

    deleteCashDepositReport: (id: number) => `${apiBaseUrl}/operations/delete-deposit/${id}`,

    debitNoteList: () => `${apiBaseUrl}/operations/debit-note/list`,

    debitNoteCreate: () => `${apiBaseUrl}/operations/debit-note/create`,

    debitNoteUpdate: (id: number) => `${apiBaseUrl}/operations/debit-note/update/${id}`,

    debitNoteDetails: () => `${apiBaseUrl}/operations/debit-note/details`,

    missedCashDeposit: () => `${apiBaseUrl}/operations/missed-cash-deposit-report`,

    cashBills: () => `${apiBaseUrl}/operations/cash-deposit-bill-list-collection-report`,

    cashReconValidate: () => `${apiBaseUrl}/operations/cash-deposit-recon-validate`,

    debitNoteConfig: () => `${apiBaseUrl}/operations/debit-note/generic-configuration/list`,

    cashReconDateConfig: (centerId: number) => `${apiBaseUrl}/operations/cashrecon_configuration/${centerId}`,

    cashDepositCMS: () => `${apiBaseUrl}/operations/cash-deposit-cms`,

    fetchInventorydata: () => `${apiBaseUrl}/operations/auto-inventory-consumption-list`,

    SOHBasesItems: () => `${apiBaseUrl}/operations/soh-based-item-list`,

    brandsList: () => `${apiBaseUrl}/operations/soh-based-brand-list`,

    getCenterWiseList: () => `${apiBaseUrl}/operations/auto-inventory-deviation-report-center-wise/list`,

    getItemWiseList: () => `${apiBaseUrl}/operations/auto-inventory-deviation-report-item-wise/list`,

    fetchDebitNotReport: () => `${apiBaseUrl}/operations/debit-note-reports`,

    getPendingAtValues: () => `${apiBaseUrl}/operations/debit-note/all-pending-at-values`,
    
    fetchSohReport: (id: number) => `${apiBaseUrl}/operations/soh-view/${id}`,

    fetchSohHistory: (id: number) => `${apiBaseUrl}/operations/soh-history/${id}`,
    fetchSohItemHistory: (centerId: number, productId: string) => `${apiBaseUrl}/operations/soh-history/${centerId}/item-history/${productId}`,

    fetchCashDepositStatsData:()=> `${apiBaseUrl}/operations/cash-deposit-stats`,
  },

  RR: {
    createRR: () => `${apiBaseUrl}/rr/create-rr`,

    getRRDetails: (id: number) => `${apiBaseUrl}/rr/rr-view-ticket-details-by-ref-no/${id}`,

    getRRList: () => `${apiBaseUrl}/rr/rr-view-tickets`,

    getRRSubGroup: () => `${apiBaseUrl}/rr/get-rr-sub-type-list`,

    getRRSubTypeById: () => `${apiBaseUrl}/rr/get-rr-sub-type-list`,

    rrSubtypeMasterCreate: () => `${apiBaseUrl}/rr/create-rr-sub-type`,

    rrSubtypeMasterDelete: (id: number) => `${apiBaseUrl}/rr/delete-rr-sub-type/${id}`,

    rrSubtypeMasterUpdate: (id: number) => `${apiBaseUrl}/rr/update-rr-sub-type/${id}`,

    updateRR: (id: string) => `${apiBaseUrl}/rr/update-rr/${id}`,

    rRIdSubscribe: (id: string) => `${apiBaseUrl}/rr/subscribe/${id}`,

    addComments: () => `${apiBaseUrl}/rr/add-comment`,

    addReplyComments: () => `${apiBaseUrl}/rr/add-reply`,

    updateRRComment: (rrCommentId: number) => `${apiBaseUrl}/rr/update-rr-comment/${rrCommentId}`,

    fetchSlaConfig: () => `${apiBaseUrl}/rr/get-sla-master-list`,

    updateSLAConfig: () => `${apiBaseUrl}/rr/add-update-sla-configuration`,

    deleteSLAConfig: (sla_id: number) => `${apiBaseUrl}/rr/delete-rr-sla-config/${sla_id}`,

    getSLAConfig: () => `${apiBaseUrl}/rr/get-rr-sla-config`,

    getMachineInfo: (id: number) => `${apiBaseUrl}/rr/get_machine/${id}`,

    getBreakdownTypes: () => `${apiBaseUrl}/rr/get_breakdown_types`,

    getIssueTypes: (id: number) => `${apiBaseUrl}/rr/get_issue_types/${id}`,
    
    createServiceRequest: () => `${apiBaseUrl}/rr/request/create`,

    createPreventiveRoRequest: () => `${apiBaseUrl}/rr/request/create-preventive-ro`,

    createRequestNote: () => `${apiBaseUrl}/rr/create_request_note`,

    getRequestNote: (id: number) => `${apiBaseUrl}/rr/get_request_notes/${id}`,

    getRequestDetails: (id: number) => `${apiBaseUrl}/rr/request/details/${id}`,

    getRequestTaskDetails: (id: number) => `${apiBaseUrl}/rr/get_request_task/${id}`,

    getServiceRequests: () => `${apiBaseUrl}/rr/get_service_requests`,

    createCondemnRequest: () => `${apiBaseUrl}/rr/request/condemn`,

    // getEventStatusList: (eventId: number) => `${apiBaseUrl}/rr/get_event_status/${eventId}`,
    getEventStatusList: () => `${apiBaseUrl}/rr/request-event-type-status`,
    // getEventStatusList: (eventId: number) => `${apiBaseUrl}/rr/get_event_status/${eventId}`,

    upsertCenterVisit: () => `${apiBaseUrl}/rr/upsert_center_vist`,

    getCenterVisitDetails: (id: any) => `${apiBaseUrl}/rr/get_center_vist_by_task_id/${id}`,

    upsertInspectionDetails: () => `${apiBaseUrl}/rr/update_inspection`,

    getInspectionDetails: (id: any) => `${apiBaseUrl}/rr/get_inspection_details_by_task_id/${id}`,

    getPartCategoriesByRequestId: (id: any) => `${apiBaseUrl}/rr/get_part_categories_by_request_id/${id}`,

    getSavedPartsByRequestId: (id: any) => `${apiBaseUrl}/rr/get_parts_by_request_id/${id}`,

    getPartsListByRequestId: (id: any) => `${apiBaseUrl}/rr/get_master_parts_by_request_id/${id}`,

    getCondemnMachineDetailsById: (id: any) => `${apiBaseUrl}/rr/condemn-request/${id}`,

    approveRequest: () => `${apiBaseUrl}/rr/request/reject_or_approve`,

    approvalDetailsForRequest: (id: any) => `${apiBaseUrl}/rr/get_approval_details_by_request_id/${id}`,

    completeCondemn:() => `${apiBaseUrl}/rr/request/complete-condemn`,

    scrapMachineSubmit:() => `${apiBaseUrl}/rr/request/scrap-machine`,

    getCondemnDetailsByIdandEventId:(id: any, eventId: any) =>  `${apiBaseUrl}/rr/get_condemn_task_details_by_id/${id}/${eventId}`,

    getInventoryPartsListByRequestId: (id: any) => `${apiBaseUrl}/rr/inventory-summary/${id}`,

    getAvailableInventoryPartsByRequestId: (id: any) => `${apiBaseUrl}/rr/inventory-parts/${id}`,

    approveSparePartRequestForRequestId: (id: any) => `${apiBaseUrl}/rr/approve/spare-parts/${id}`,

    updatePartPackagingForRequest: () => `${apiBaseUrl}/rr/request/update_package_details`,

    updatePartAcknowledgementRequest: () => `${apiBaseUrl}/rr/request/spare_parts_received`,

    updateOldPartInstallationRequest: () => `${apiBaseUrl}/rr/spare_part/update_part_installation`,

    updateNewPartInstallationRequest: () => `${apiBaseUrl}/rr/new_spare_part/update_part_installation`,

    updatePODetailsForRequest: () => `${apiBaseUrl}/rr/request/update_po`,

    getRequestTaskFlow: (id: any) => `${apiBaseUrl}/rr/request/task_flow/${id}`,

    getMachinesListForCenter: () => `${apiBaseUrl}/rr/request-type/machine`,

    getStatuswisesummary: (service_request:any) =>`${apiBaseUrl}/rr/requests/status_wise_summary/${service_request}`,
    // getMachinesListForCenter: () => `${apiBaseUrl}/rr/get_machines_by_center_id`,
    updateDiasafeAcknowledgement: () => `${apiBaseUrl}/rr/diasafe-request`,

    createDiasafeRequest: () =>  `${apiBaseUrl}/rr/create/diasafe-request`,

    createAssetTransferRequest: () => `${apiBaseUrl}/rr/create/asset_transfer`,

    getRequestTypes: () => `${apiBaseUrl}/rr/get_request_types`,
    
    createSoftnerRegenerationRequest: () => `${apiBaseUrl}/rr/create/maintenance-request`,

    getMaintenanceRequestsList: () => `${apiBaseUrl}/rr/request/maintenance`,

    getOdometerRequestsList: () => `${apiBaseUrl}/rr/request/odometer`,

    getOdometerRequestDetails: (id: any) => `${apiBaseUrl}/rr/request/odometer_details/${id}`,
    
    updateOdometerRequestDetails: () => `${apiBaseUrl}/rr/request/update_odometer`,

    getMaintenanceRequestById: (id: any) => `${apiBaseUrl}/rr/request/maintenance/details/${id}`,

    createTdsTask: () => `${apiBaseUrl}/rr/upsert/tds-task`,

    getTdsTaskList: () => `${apiBaseUrl}/rr/request/tds-task-list`,

    getMaintenanceRequestTdsById: (id: any) => `${apiBaseUrl}/rr/request/tds/details/${id}`,

    getAssetTransferRequests: () => `${apiBaseUrl}/rr/asset_transfers`,

    getAssetTransferRequestById: (id: any) => `${apiBaseUrl}/rr/request/asset_transfers/details/${id}`,

    assetTransferFinanceValuation: (id: number) => `${apiBaseUrl}/rr/asset_transfer/update_valuation/${id}`,

    updateAssetTransferReception: (id: number) => `${apiBaseUrl}/rr/asset_transfer/update_asset_reception/${id}`,
    
    updateAssetDistanceValuation: (id: number) => `${apiBaseUrl}/rr/asset_transfer/update_distance/${id}`,
    
    updateAssetTransferLogisticsPo: (id: number) => `${apiBaseUrl}/rr/asset_transfer/update_logistics_po/${id}`,

    updateAssetTransferTransportQuotes: (id: number) => `${apiBaseUrl}/rr/asset_transfer/update_transport_quotes/${id}`,

    getROServiceTicketList: () => `${apiBaseUrl}/rr/request/service-ticket`,

    getRoServiceTicketById: (id: any) => `${apiBaseUrl}/rr/request/service_ticket/details/${id}`,

    createRoServiceTicketRequest: () => `${apiBaseUrl}/rr/create/service-ticket`,

    updateROInspection: (id: any) => `${apiBaseUrl}/rr/update/service-ticket/${id}`,

    getAuditList: () => `${apiBaseUrl}/rr/audit_list`,

    getAuditQuestionaries: (id: any) =>  `${apiBaseUrl}/rr/audit/list/${id}`,

    createAuditRequest: () => `${apiBaseUrl}/rr/create/audit`,

    getAuditRequestDetails: (id: any) => `${apiBaseUrl}/rr/audit/get_info/${id}`,

    submitAuditRequest: () => `${apiBaseUrl}/rr/audits/submit`,

    serviceReportById: (id: any) => `${apiBaseUrl}/rr/service-request/pdf/${id}`,

    masterDataList: () => `${apiBaseUrl}/rr/master-data/list`,

    getInspectionPartDetails: (id: any) => `${apiBaseUrl}/rr/request/spare_part_details_by_service_request/${id}`,
    
    getNotificationList: () => `${apiBaseUrl}/rr/notification/list`,

    getNotificationCount: () => `${apiBaseUrl}/rr/notification/count`,

    updateNotificationStatus: (id:any) => `${apiBaseUrl}/rr/notification/read/${id}`,

    createRFIdRequest: () => `${apiBaseUrl}/rr/request/rfid/create`,

    uploadRFIDData: () => `${apiBaseUrl}/rr/rfid/upload`,

    rfIdAcknowledgement: () => `${apiBaseUrl}/rr/rfid/acknowledge`,

    getRFIdListForRequest: () => `${apiBaseUrl}/rr/request/rfid/list`,

    getMasterSparePartsList: () => `${apiBaseUrl}/rr/master/spare_parts`,

    getAmogaMasters: () => `${apiBaseUrl}/rr/amoga/master_data`,

    upsertSparePart: () => `${apiBaseUrl}/rr/master/spare_parts`,

    fetchInventoryMasterList: () => `${apiBaseUrl}/rr/master/inventory`,

    masterRequestStatusList: () => `${apiBaseUrl}/rr/request-status/list`,

    taskBasedAssigneeList: () => `${apiBaseUrl}/rr/event_assignee/list`,

    updateTaskAssignee: (requestId: any, eventId: any, assigneeId: any) => `${apiBaseUrl}/rr/update_assignee/${requestId}/${eventId}/${assigneeId}`

  },

  QUALITY: {
    createDailyReport: () => `${apiBaseUrl}/quality/daily-quality-report/create-report`,

    createDialysate: () => `${apiBaseUrl}/quality/dialysate/create-report`,

    getDailyReportDetail: (id: string) => `${apiBaseUrl}/quality/daily-quality-report/view-report/${id}`,

    listDailyReport: () => `${apiBaseUrl}/quality/daily-quality-report/view-report`,

    listDialysateReport: () => `${apiBaseUrl}/quality/dialysate/view-report`,

    machineList: () => `${apiBaseUrl}/quality/dialysate/machine-type/list`,

    getDialysateDetailReport: (id: string) => `${apiBaseUrl}/quality/dialysate/view-report/${id}`,

    updateDialysateReport: (id: string) => `${apiBaseUrl}/quality/dialysate/edit-report/${id}`,

    updateDailyReport: (id: string) => `${apiBaseUrl}/quality/daily-quality-report/edit-report/${id}`,
  },

  EXPORT: {
    guestsList: () => `${apiBaseUrl}/report_export/report-export-guest/guest-list`,
    guestIrregularReport: () => `${apiBaseUrl}/report_export/report-export-guest/guest-irregular-report/`,
    approvalPendingBhavyaPatientList: () =>
      `${apiBaseUrl}/report_export/report-export-guest/approval-pending-guests-with-bhavya-id`,

    staffList: () => `${apiBaseUrl}/hr/staff-list`,

    listDailyReport: () => `${apiBaseUrl}/quality/daily-quality-report/view-report`,
    listDialysateReport: () => `${apiBaseUrl}/quality/dialysate/view-report`,

    listPreAuth: () => `${apiBaseUrl}/billing/pre-auth/list`,

    getRRList: () => `${apiBaseUrl}/rr/rr-view-tickets`,

    missedSessions: () => `${apiBaseUrl}/billing/view-missed-session/`,
    downloadSession: () => `${apiBaseUrl}/billing/download-schedules-guest/`,

    listBills: () => `${apiBaseUrl}/report/bill_list`,
    todaysBillList: () => `${apiBaseUrl}/report/bo/bill_list`,
    listRatePlanList: () => `${apiBaseUrl}/billing/billing/rateplans-list`,
    listRatePlansAllList: () => `${apiBaseUrl}/billing/billing/rateplans-all-list`,
    acquisitionAttritionReports: () =>
      `${apiBaseUrl}/report_export/report-export-billing/acquisition-attrition-report-list`,
    packageUtilizationReports: () => `${apiBaseUrl}/report_export/report-export/package-utilization-report-list`,
    depositUtilizationReports: () => `${apiBaseUrl}/report_export/report-export/deposit-utilization-report`,
    fetchYesterdaysRevenueReport: () =>
      `${apiBaseUrl}/report_export/report-export/yesterdays-guest-session-revenue-report`,
    collectionReport: () => `${apiBaseUrl}/report_export/report-export/collection-report-list`,
    todaysCollectionReport: () => `${apiBaseUrl}/billing/todays-collection-report`,
    TodaysRevenueReport: () => `${apiBaseUrl}/billing/todays-revenue-report`,

    centerList: () => `${apiBaseUrl}/billing/center-list`,
    listAuditReport: () => `${apiBaseUrl}/operations/audit-report`,
    getCashDepositReportList: () => `${apiBaseUrl}/operations/cash-deposit`,
    listRevenueDailyReport: () => `${apiBaseUrl}/operations/revenue-report-vs-daily-report-session`,
    listDialyReport: () => `${apiBaseUrl}/operations/daily-report`,

    investigationReport: () => `${apiBaseUrl}/report_export/report-export-clinical/investigation-report`,
    viralMarkersReport: () => `${apiBaseUrl}/report_export/report-export-clinical/viral-markers-report/get-list`,
    adverseEventList: () => `${apiBaseUrl}/report_export/report-export-clinical/adverse-event-report`,
    eq5dQualitySurveyList: () => `${apiBaseUrl}/report_export/report-export-clinical/eq5d_quality_survey/view`,
    hepBVaccinationReport: () =>
      `${apiBaseUrl}/report_export/report-export-clinical/prescription/hep_b_vaccination_report`,
    accessList: () => `${apiBaseUrl}/report_export/report-export-clinical/access-list-report/`,
    prescriptionEntry: () => `${apiBaseUrl}/report_export/report-export-clinical/prescription-entry/`,
    prescriptionDetailReport: () => `${apiBaseUrl}/report_export/report-export-clinical/guest-prescription-report/`,
    monthlyInvestigationSummaryReport: () =>
      `${apiBaseUrl}/report_export/report-export-clinical/monthly-investigation-summary`,
    centerLongitudinalReport: () => `${apiBaseUrl}/report_export/report-export-clinical/center-longitudinal-report`,
    guestSpecificLongitudinalReport: () =>
      `${apiBaseUrl}/report_export/report-export-clinical/guest-specific-longitudinal-report`,
  },

  INVENTOR: {
    listInventoryReport: () => `${apiBaseUrl}/operations/auto-inventory-consumption-list`,
    saveInventory: () => `${apiBaseUrl}/operations/auto-inventory-deduction`,
    listDaviationReport: () => `${apiBaseUrl}/operations/auto-inventory-deviation-report/list`,
  },
};
